<template>
  <div>
    <Widget>
      <form-wizard
        shape="tab"
        color="#3498db"
        title=""
        subtitle=""
        @on-change="updateProgress"
        @on-loading="updateProgress(1, 1)"
      >
        <b-progress
          class="progress-xs"
          variant="info"
          :value="progress"
          :max="2"
        />
        <b-button slot="prev" variant="primary" class="text-white">
          <i class="fa fa-caret-left" /> Previous
        </b-button>
        <b-button slot="next" variant="primary" class="text-white">
          Next <i class="fa fa-caret-right" />
        </b-button>
        <b-button slot="finish" variant="success" class="text-white" @click="finish()">
          Finish <i class="fa fa-check" />
        </b-button>
        <tab-content
          title="Formulir Pendaftaran"
          style="background-color: white"
        >
          <legend>Form Pendaftaran Permohonan</legend>
          <div class="row">
            <div class="col-md-6">
              <label>NIK Pemohon</label>
              <b-form-input v-model="form.nik_pemohon"></b-form-input>
            </div>
            <div class="col-md-6">
              <label>NPWP Pemohon</label>
              <b-form-input v-model="form.npwp_pemohon"></b-form-input>
            </div>
            <div class="col-md-6 mt-3">
              <label>Nama Pemohon</label>
              <b-form-input v-model="form.nama_pemohon"></b-form-input>
            </div>
            <div class="col-md-6 mt-3">
              <label>Jabatan Pemohon</label>
              <b-form-input v-model="form.jabatan_pemohon"></b-form-input>
            </div>

            <div class="col-md-6 mt-3">
              <label>Instansi Pemohon</label>
              <b-form-input v-model="form.instansi_pemohon"></b-form-input>
            </div>
            <div class="col-md-6 mt-3">
              <label>Alamat Pemohon</label>
              <b-form-textarea v-model="form.alamat_pemohon"></b-form-textarea>
            </div>

            <div class="col-md-6 mt-3">
              <label>No. Handphone Pemohon</label>
              <b-form-input v-model="form.no_hp_pemohon"></b-form-input>
            </div>

            <div class="col-md-6 mt-3">
              <label>No. Telphone Pemohon</label>
              <b-form-input v-model="form.no_telepon_pemohon"></b-form-input>
            </div>

            <div class="col-md-6 mt-3">
              <label>Email Pemohon</label>
              <b-form-input v-model="form.email_pemohon"></b-form-input>
            </div>

            <div class="col-md-6 mt-3">
              <label>Provinsi</label>
              <v-select
                id="default-select"
                v-model="form.provinsi"
                :reduce="(data) => data.nama_provinsi"
                label="nama_provinsi"
                :options="dataProvinsi"
                v-validate="'required'"
                @input="getKabupaten()"
                name="Provinsi"
              />
            </div>
            <div class="col-md-6 mt-3">
              <label>Kabupaten</label>
              <v-select
                id="default-select"
                v-model="form.kabupaten"
                :reduce="(data) => data.nama_kabupaten"
                label="nama_kabupaten"
                :options="dataKabupaten"
                v-validate="'required'"
                @input="getKecamatan()"
                name="Kabupaten"
              />
            </div>
            <div class="col-md-6 mt-3">
              <label>Kecamatan</label>
              <v-select
                id="default-select"
                v-model="form.kecamatan"
                :reduce="(data) => data.nama_kecamatan"
                label="nama_kecamatan"
                :options="dataKecamatan"
                v-validate="'required'"
                name="Kecamatan"
              />
            </div>
            <div class="col-md-6 mt-3">
              <label>Jenis Kegiatan</label>
              <b-form-input v-model="form.jenis_kegiatan"></b-form-input>
            </div>
            <!-- <div class="col-md-6 mt-3">
              <label>Skala Usaha</label>
              <v-select
                id="default-select"
                v-model="form.skala_usaha"
                :options="dataSkalaUsaha"
                v-validate="'required'"
                name="Skala Usaha"
              />
            </div> -->
            <div class="col-md-6 mt-3">
              <label>Reklamasi</label>
              <v-select
                id="default-select"
                v-model="form.reklamasi"
                :reduce="(data) => data.value"
                label="text"
                :options="dataReklamasi"
                v-validate="'required'"
                name="Reklamasi"
              />
            </div>
            <div class="col-md-6 mt-3">
              <label>Nama Perairan</label>
              <b-form-input v-model="form.nama_perairan"></b-form-input>
            </div>
            <div class="col-md-6 mt-3">
              <label>PSN</label>
              <v-select
                id="default-select"
                v-model="form.psn"
                :options="dataPSN"
                v-validate="'required'"
                name="PSN"
              />
            </div>
            <div class="col-md-2 mt-3">
              <label>Luas (Ha)</label>
              <b-form-input v-model="form.luas"></b-form-input>
            </div>
            <div class="col-md-2 mt-3">
              <label>Panjang (Km)</label>
              <b-form-input v-model="form.panjang"></b-form-input>
            </div>
            <div class="col-md-2 mt-3">
              <label>Kedalaman (mdpl)</label>
              <b-form-input v-model="form.kedalaman"></b-form-input>
            </div>
          </div>
        </tab-content>
        <tab-content title="Dokumen" style="background-color: white">
          <b-form>
            <b-row>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Surat Permohonan Perizinan Non Berusaha
                </p>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_7"
                    accept=".pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <b-button
                    v-if="file_7 == null"
                    disabled
                    variant="primary"
                    @click="simpanFile('surat')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanFile('surat')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <!-- <b-button variant="success" v-if="form.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <b-button
                    variant="success"
                    v-if="form.filename_surat_permohonan_perizinan_nonberusaha == null"
                    disabled
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tidak ada data"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-download" /> Download</b-button
                  >
                  <a
                    :href="form.filename_surat_permohonan_perizinan_nonberusaha"
                    v-else
                    type="button"
                    class="btn btn-success"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="fa fa-download" /> Download</a
                  >
                  <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                </b-form-group>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">Koordinat</p>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_1"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <b-button
                    v-if="file_1 == null"
                    disabled
                    variant="primary"
                    @click="simpanFile('kordinat')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanFile('kordinat')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >

                  <b-button
                    variant="success"
                    v-if="form.file_kordinat == null"
                    disabled
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tidak ada data"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-download" /> Download</b-button
                  >
                  <a
                    :href="form.file_kordinat"
                    v-else
                    type="button"
                    class="btn btn-success"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="fa fa-download" /> Download</a
                  >
                </b-form-group>
              </b-col>
              <div class="divider div-transparent"></div>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Rencana Bangunan dan Instalasi di Laut
                </p>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_2"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-button
                  variant="primary"
                  v-if="file_2 == null"
                  disabled
                  @click="simpanFile('bangunan')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                >
                <b-button
                  variant="primary"
                  v-else
                  @click="simpanFile('bangunan')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                >
                <!-- <b-button variant="success" v-if="form.file_rencana_bangunan_dan_instalasi_di_laut != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="
                    form.file_rencana_bangunan_dan_instalasi_di_laut == null
                  "
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="form.file_rencana_bangunan_dan_instalasi_di_laut"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1 hr-blurry" md="12">
                        </b-col> -->
              <b-col md="12">
                <div class="hr-sect">Rencana Kegiatan</div>
              </b-col>
              <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col> -->
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->

              <b-col md="8">
                <div>
                  Dokumen dasar berupa kegiatan, tujuan dan manfaat kegiatan
                  usaha
                </div>
              </b-col>
              <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
              
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>

              <b-col md="5">
                <div>Kegiatan eksisting yang dimohonkan</div>
              </b-col>
              <b-col md="3">
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Rencana jadwal pelaksanaan kegiatan utama dan pendukungnya
                </div>
              </b-col>
             
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Rencana tapak/site plan kegiatan yang dilengkapi dengan
                  rencana bangunan dan instalasi di laut serta fasilitas
                  penunjangnya
                </div>
              </b-col>
             
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Deksriptif luasan (Ha) yang dibutuhkan pada lokasi usaha yang
                  dimohonkan per kegiatan utama dan penunjangnya
                </div>
              </b-col>
              
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Peta lokasi/plotting batas-batas area dan/atau jalur disertai
                  titik koordinat lokasi dengan sistem koordinat lintang
                  (latitude) dan bujur (longitude) berskala minimal 1:50.000.
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>
                  <p style="font-weight: 900; font-size: 17px">
                    Informasi Pemanfaatan Ruang Laut
                  </p>
                </div>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_3"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <b-button
                    v-if="file_3 == null"
                    disabled
                    variant="primary"
                    @click="simpanFile('prl')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanFile('prl')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <!-- <b-button variant="success" v-if="form.file_informasi_prl != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <b-button
                    variant="success"
                    v-if="form.file_informasi_prl == null"
                    disabled
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tidak ada data"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-download" /> Download</b-button
                  >
                  <a
                    :href="form.file_informasi_prl"
                    v-else
                    type="button"
                    class="btn btn-success"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="fa fa-download" /> Download</a
                  >
                  <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                </b-form-group>
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="5">
                <div>
                  <p style="font-weight: 900; font-size: 17px">
                    Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                    hidrografi, dan oseanografi)
                  </p>
                </div>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_4"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-button
                  v-if="file_4 == null"
                  disabled
                  variant="primary"
                  @click="simpanFile('kondisi')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                >
                <b-button
                  v-else
                  variant="primary"
                  @click="simpanFile('kondisi')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                >
                <!-- <b-button variant="success" v-if="form.file_data_kondisi_terkini != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="form.file_data_kondisi_terkini == null"
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="form.file_data_kondisi_terkini"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="12">
                <div class="hr-sect">Ekosistem Sekitar</div>
              </b-col>
              <!-- <b-col md="3">
                        </b-col>
                        <b-col md="4">
                        </b-col> -->
              <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="5">
                <div>Mangrove</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Lamun</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>Terumbu karang</div>
              </b-col>

              <b-col md="12">
                <div class="hr-sect">Hidro-oseanografi</div>
              </b-col>
              <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col>
                        <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
              <b-col md="5">
                <div>Arus</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Gelombang</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Pasang Surut</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Bathimetri</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">Profil dasar laut disertai gambar</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">
                  Kondisi/karakteristik sosial ekonomi masyarakat
                </p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">Aksesibilitas lokasi dan sekitar</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Persyaratan Lainnya
                </p>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_5"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <b-button
                    v-if="file_5 == null"
                    disabled
                    variant="primary"
                    @click="simpanFile('lain')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanFile('lain')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <!-- <b-button variant="success" v-if="form.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <b-button
                    variant="success"
                    v-if="form.file_persyaratan_lain == null"
                    disabled
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tidak ada data"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-download" /> Download</b-button
                  >
                  <a
                    :href="form.file_persyaratan_lain"
                    v-else
                    type="button"
                    class="btn btn-success"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="fa fa-download" /> Download</a
                  >
                  <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                </b-form-group>
              </b-col>

              <template v-if="form.reklamasi == true">
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Reklamasi
                  </p>
                </b-col>
                <b-col md="3">
                  <b-form-group>
                    <b-form-file
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      plain
                      class="form-control"
                      v-model="file_6"
                      accept=".doc, .docx, .xlsx, .pdf"
                    ></b-form-file>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <b-button
                      v-if="file_6 == null"
                      disabled
                      variant="primary"
                      @click="simpanFile('reklamasi')"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    >
                    <b-button
                      v-else
                      variant="primary"
                      @click="simpanFile('reklamasi')"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    >
                    <!-- <b-button variant="success" v-if="form.file_persyaratan_reklamasi != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button
                      variant="success"
                      v-if="form.file_persyaratan_reklamasi == null"
                      disabled
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Tidak ada data"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-download" /> Download</b-button
                    >
                    <a
                      :href="form.file_persyaratan_reklamasi"
                      v-else
                      type="button"
                      class="btn btn-success"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><i class="fa fa-download" /> Download</a
                    >
                    <!-- <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                        <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                    </div> -->
                  </b-form-group>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Rencana pengambilan sumber material reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Rencana pemanfaatan lahan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Gambaran umum pelaksanaan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Jadwal rencana pelaksanaan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
              </template>
             
            </b-row>
            
          </b-form>
        </tab-content>
      </form-wizard>
    </Widget>
  </div>
</template>

<script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import vSelect from "vue-select";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Widget,
    vSelect,
  },
  data() {
    return {
      progress: 1,
      id_permohonan: localStorage.getItem("id_permohonan"),
      tipe: localStorage.getItem("tipe_pemohon"),
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      form: {},
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      dataSkalaUsaha: ["Besar", "Menengah", "Mikro"],
      dataPSN: ["PSN", "Non PSN"],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      inputFiles: [],
      dataPerDokumen: [],
      dataUser: [],
      file_1: null,
      file_2: null,
      file_3: null,
      file_4: null,
      file_5: null,
      file_6: null,
      file_7: null,
    };
  },
  mounted() {
    this.getProvinsi();
    if (this.id_permohonan != null && this.id_permohonan != undefined) {
      this.loadData();
    }
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        if (nextIndex == 1) {
          this.simpanForm();
        } else if (nextIndex == 2) {
            
        }
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    finish(){
        if(localStorage.getItem('tipe_pemohon') == 'Pemerintah'){
            this.$router.push('/app/permohonan/non-berusaha/pemerintah')
        }else{
            this.$router.push('/app/permohonan/non-berusaha/swasta')
        }
        localStorage.removeItem('id_permohonan')
        
    },

    loadData() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      axios
        .get(this.baseapi + "api/permohonan_nonberusaha/" + id_permohonan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi?sort=id,ASC", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
          this.getKabupaten();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKabupaten() {
      axios
        .get(
          this.baseapi +
            "api/kabupaten?filter=nama_provinsi,=," +
            this.form.provinsi,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKabupaten = response.data.data;
          this.getKecamatan();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKecamatan() {
      axios
        .get(
          this.baseapi +
            "api/kecamatan?filter=nama_kabupaten,=," +
            this.form.kabupaten,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKecamatan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async simpanForm() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      this.form.tipe_pemohon = localStorage.getItem('tipe_pemohon');
      if (id_permohonan != null) {
        // console.log(this.cabang);
        // return;
        const formData = new FormData();
        formData.append("nama_pemohon", this.form.nama_pemohon);
        formData.append("jabatan_pemohon", this.form.jabatan_pemohon);
        formData.append("instansi_pemohon", this.form.instansi_pemohon);
        formData.append("alamat_pemohon", this.form.alamat_pemohon);
        formData.append("nik_pemohon", this.form.nik_pemohon);
        formData.append("npwp_pemohon", this.form.npwp_pemohon);
        formData.append("no_hp_pemohon", this.form.no_hp_pemohon);
        formData.append("no_telepon_pemohon", this.form.no_telepon_pemohon);
        formData.append("email_pemohon", this.form.email_pemohon);
        formData.append("provinsi", this.form.provinsi);
        formData.append("kabupaten", this.form.kabupaten);
        formData.append("kecamatan", this.form.kecamatan);
        formData.append("jenis_kegiatan", this.form.jenis_kegiatan);
        formData.append("reklamasi", this.form.reklamasi);
        formData.append("nama_perairan", this.form.nama_perairan);
        formData.append("psn", this.form.psn);
        formData.append("skala_usaha", this.form.skala_usaha);
        formData.append("luas", this.form.luas);
        formData.append("panjang", this.form.panjang);
        formData.append("kedalaman", this.form.kedalaman);
        axios
          .post(
            this.baseapi + "api/permohonan_nonberusaha/" + id_permohonan,
            formData,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((response) => {
            Swal.fire("Berhasil", "" + response.data.message + "", "success");
            this.getDataFirst();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.form.tanggal_permohonan = Date.now();
        axios
          .post(this.baseapi + "api/permohonan_nonberusaha", this.form, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((response) => {
            localStorage.setItem("id_permohonan", response.data.data.id)
            Swal.fire("Berhasil", "" + response.data.message + "", "success");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    simpanFile(jenis) {
      const id_permohonan = localStorage.getItem("id_permohonan");
      let formData = new FormData();
      if (jenis == "kordinat") {
        formData.append("file_kordinat", this.file_1);
      }else if (jenis == "bangunan") {
        formData.append("file_rencana_bangunan_dan_instalasi_di_laut", this.file_2);
      }else if (jenis == "prl") {
        formData.append("file_informasi_prl", this.file_3);
      }else if (jenis == "kondisi") {
        formData.append("file_data_kondisi_terkini", this.file_4);
      }else if (jenis == "lain") {
        formData.append("file_persyaratan_lain", this.file_5);
      }else if (jenis == "reklamasi") {
        formData.append("file_persyaratan_reklamasi", this.file_6);
      }else if (jenis == "surat") {
        formData.append("filename_surat_permohonan_perizinan_nonberusaha", this.file_7);
      }

      axios
        .post(
          this.baseapi + "api/permohonan_nonberusaha/" + id_permohonan,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.file_1 = null
          this.file_2 = null
          this.file_3 = null
          this.file_4 = null
          this.file_5 = null
          this.file_6 = null
          this.file_7 = null
          this.loadData();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },
    onChangeInputFiles(e) {
      const files = [];
      let i = 0;
      for (i; i < e.target.files.length; i += 1) {
        files.push(e.target.files[i]);
      }

      Vue.set(this, "inputFiles", files);
    },
    removeFiles() {
      Vue.set(this, "inputFiles", []);
    },
  },
};
</script>